import INTENDED_USE from '../definitions/IntendedUse';


/**
 * 
 * @param {string} intendedUse 
 * @returns 
 */
function getIsOwnerOccupiedFromIntendedUse(intendedUse) {
    return [
        INTENDED_USE.OWNER_OCCUPIED,
        INTENDED_USE.OWNER_OCCUPIED_RENTAL,
    ].includes(intendedUse);
}

export default getIsOwnerOccupiedFromIntendedUse;